<template>
  <div v-if="portalProfileForm != null" id="show-nas">
    <v-tabs-items v-model="global.selectedAppTab">
      <v-tab-item class="pt-3 pb-1">
        <portal-options-technical-card
          :is-portal-profile="true"
          :partner="portalProfileForm.partner"
          :portal-options="portalProfileForm.portalOptions"
          @update:portalOption="portalProfileForm.portalOptions = $event"
        ></portal-options-technical-card>
      </v-tab-item>
      <v-tab-item class="pt-3 pb-1">
        <div v-if="global.selectedAppTab == 1">
          <v-row>
            <v-col cols="12">
              <v-card :loading="colorsLoading">
                <v-card-title>
                  Couleurs
                  <v-spacer></v-spacer>
                  <v-btn v-if="editMode" icon @click="saveTheme">
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                  <v-btn v-else icon @click="editMode = true">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <edit-portal-presentation-theme-form
                    :isInherit="false"
                    :portalConfiguration.sync="
                      portalProfileForm.portalConfiguration
                    "
                    :portalConfigurationModel="
                      portalProfileForm.portalConfigurationModel
                    "
                    :isBuiltIn="false"
                    :isPortalProfile="true"
                    :portalOptionsId="portalProfileForm.portalOptions.id"
                    :updatePortalConfiguration="updatePortalConfiguration"
                    :id="portalProfileForm.id"
                    :group="null"
                    :isGroup="false"
                    :partner="portalProfileForm.partner"
                    :rules="portalConfigurationRules"
                    :portalPresentationThemeDialog.sync="
                      portalPresentationThemeDialog
                    "
                    :editMode="editMode"
                    ref="editTheme"
                  ></edit-portal-presentation-theme-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-tab-item>
      <v-tab-item class="pt-3 pb-1">
        <div v-if="global.selectedAppTab == 2">
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-title
                  >Présentation
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="primary float-right"
                    dark
                    @click="[(portalConfigurationPresentationDialog = true)]"
                  >
                    <v-icon>mdi-pencil</v-icon>
                    Editer</v-btn
                  >
                  <edit-portal-configuration-presentation-form
                    v-if="portalConfigurationPresentationDialog"
                    :isInherit="false"
                    :portalConfiguration="portalProfileForm.portalConfiguration"
                    :portalConfigurationModel="
                      portalProfileForm.portalConfigurationModel
                    "
                    :isBuiltIn="false"
                    :isPortalProfile="true"
                    :portalOptionsId="portalProfileForm.portalOptions.id"
                    :updatePortalConfiguration="updatePortalConfiguration"
                    :id="portalProfileForm.id"
                    :group="null"
                    :isGroup="false"
                    :partner="portalProfileForm.partner"
                    :portalConfigurationDialog="portalConfigurationDialog"
                    :rules="portalConfigurationRules"
                    :portalConfigurationPresentationDialog.sync="
                      portalConfigurationPresentationDialog
                    "
                  ></edit-portal-configuration-presentation-form>
                </v-card-title>
                <v-card-text>
                  <div
                    v-if="
                      portalProfileForm.portalConfigurationModel
                        .basic_presentation
                    "
                  >
                    <span> Présentation BASIC : </span>
                    <span class="font-weight-bold">
                      <span
                        v-if="
                          portalProfileForm.portalConfiguration
                            .basic_presentation != null &&
                          portalProfileForm.portalConfiguration
                            .basic_presentation.access != null &&
                          portalProfileForm.portalConfiguration
                            .basic_presentation.access.length > 0
                        "
                      >
                        <v-icon>mdi-check </v-icon> (
                        {{
                          portalProfileForm.portalConfiguration
                            .basic_presentation.payment
                        }}
                        )
                      </span>

                      <v-icon v-else>mdi-close</v-icon>
                    </span>
                  </div>
                  <div
                    v-if="
                      portalProfileForm.portalConfigurationModel
                        .basic_presentation &&
                      portalProfileForm.portalConfiguration
                        .basic_presentation != null &&
                      portalProfileForm.portalConfiguration.basic_presentation
                        .access != null &&
                      portalProfileForm.portalConfiguration.basic_presentation
                        .access.length > 0
                    "
                  >
                    <span> Type de présentation BASIC : </span>
                    <span class="font-weight-bold">
                      <span>
                        {{
                          portalProfileForm.portalConfiguration.basic_presentation.access.toString()
                        }}
                      </span>
                    </span>
                    <v-divider></v-divider>
                  </div>

                  <div
                    v-if="
                      portalProfileForm.portalConfigurationModel
                        .full_presentation
                    "
                  >
                    <span> Présentation FULL : </span>
                    <span class="font-weight-bold">
                      <span
                        v-if="
                          portalProfileForm.portalConfiguration
                            .full_presentation != null &&
                          portalProfileForm.portalConfiguration
                            .full_presentation.access != null &&
                          portalProfileForm.portalConfiguration
                            .full_presentation.access.length > 0
                        "
                      >
                        <v-icon>mdi-check </v-icon> (
                        {{
                          portalProfileForm.portalConfiguration
                            .full_presentation.payment
                        }}
                        )
                      </span>

                      <v-icon v-else>mdi-close</v-icon>
                    </span>
                  </div>
                  <div
                    v-if="
                      portalProfileForm.portalConfigurationModel
                        .full_presentation &&
                      portalProfileForm.portalConfiguration.full_presentation !=
                        null &&
                      portalProfileForm.portalConfiguration.full_presentation
                        .access != null &&
                      portalProfileForm.portalConfiguration.full_presentation
                        .access.length > 0
                    "
                  >
                    <span> Type de présentation FULL : </span>
                    <span class="font-weight-bold">
                      <span>
                        {{
                          portalProfileForm.portalConfiguration.full_presentation.access.toString()
                        }}
                      </span>
                    </span>
                    <v-divider></v-divider>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title
                  >Langues
                  <v-spacer></v-spacer>

                  <v-btn
                    @click="[(portalConfigurationLanguageDialog = true)]"
                    icon
                    color="rba(0,0,0,0.54)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                    <slot></slot>
                  </v-btn>

                  <edit-portal-configuration-language-form
                    v-if="portalConfigurationLanguageDialog"
                    :isInherit="false"
                    :portalConfiguration="portalProfileForm.portalConfiguration"
                    :portalConfigurationModel="
                      portalProfileForm.portalConfigurationModel
                    "
                    :isBuiltIn="false"
                    :isPortalProfile="true"
                    :portalOptionsId="portalProfileForm.portalOptions.id"
                    :updatePortalConfiguration="updatePortalConfiguration"
                    :id="portalProfileForm.id"
                    :group="null"
                    :isGroup="false"
                    :partner="portalProfileForm.partner"
                    :portalConfigurationDialog="portalConfigurationDialog"
                    :rules="portalConfigurationRules"
                    :portalConfigurationLanguageDialog="
                      portalConfigurationLanguageDialog
                    "
                    @update:portalConfigurationLanguageDialog="
                      portalConfigurationLanguageDialog = $event
                    "
                  ></edit-portal-configuration-language-form>
                </v-card-title>
                <v-card-text>
                  <v-row
                    v-if="
                      portalProfileForm.portalConfiguration.languages != null &&
                      portalProfileForm.portalConfiguration.languages.length > 0
                    "
                  >
                    <v-col cols="4">
                      <div>
                        <span>Langues :</span>
                        <span class="font-weight-bold">
                          {{
                            portalProfileForm.portalConfiguration.languages.toString()
                          }}
                        </span>
                      </div>
                      <v-divider></v-divider>
                      <div>
                        <span> Langue par défault : </span>
                        <span class="font-weight-bold">
                          {{
                            portalProfileForm.portalConfiguration
                              .default_language
                          }}
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-title>
                  Autres
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="primary float-right"
                    dark
                    @click="[(portalConfigurationOtherDialog = true)]"
                  >
                    <v-icon>mdi-pencil</v-icon>
                    Editer</v-btn
                  >
                  <edit-portal-configuration-other-form
                    v-if="portalConfigurationOtherDialog"
                    :isInherit="false"
                    :portalConfiguration="portalProfileForm.portalConfiguration"
                    :portalConfigurationModel="
                      portalProfileForm.portalConfigurationModel
                    "
                    :isBuiltIn="false"
                    :isPortalProfile="true"
                    :portalOptionsId="portalProfileForm.portalOptions.id"
                    :updatePortalConfiguration="updatePortalConfiguration"
                    :id="portalProfileForm.id"
                    :group="null"
                    :isGroup="false"
                    :partner="portalProfileForm.partner"
                    :portalConfigurationDialog="portalConfigurationDialog"
                    :rules="portalConfigurationRules"
                    :portalConfigurationOtherDialog="
                      portalConfigurationOtherDialog
                    "
                    @update:portalConfigurationOtherDialog="
                      portalConfigurationOtherDialog = $event
                    "
                  ></edit-portal-configuration-other-form>
                </v-card-title>
                <v-card-text>
                  <div
                    v-if="
                      portalProfileForm.portalConfigurationModel.user_form !=
                        null &&
                      portalProfileForm.portalConfiguration.user_form != null &&
                      portalProfileForm.portalConfiguration.user_form.length > 0
                    "
                  >
                    <span> Champs du formulaire : </span>
                    <span class="font-weight-bold">
                      {{
                        portalProfileForm.portalConfiguration.user_form.toString()
                      }}
                    </span>
                    <v-divider></v-divider>
                  </div>

                  <div
                    v-if="
                      portalProfileForm.portalConfiguration.ad != null &&
                      portalProfileForm.portalConfigurationModel.has_ad != null
                    "
                  >
                    <span> Publicité active : </span>
                    <span class="font-weight-bold">
                      <v-icon
                        v-if="
                          portalProfileForm.portalConfiguration.ad != null &&
                          portalProfileForm.portalConfiguration.ad.is_active
                        "
                        >mdi-check
                      </v-icon>
                      <v-icon v-else>mdi-close</v-icon>
                    </span>
                    <v-divider></v-divider>
                  </div>
                  <div
                    v-if="
                      portalProfileForm.portalConfigurationModel
                        .has_card_at_reception
                    "
                    Type
                    de
                    présentation
                  >
                    <span> Cartes à la réception : </span>
                    <span class="font-weight-bold">
                      <v-icon
                        v-if="
                          portalProfileForm.portalConfiguration
                            .has_card_at_reception
                        "
                        >mdi-check
                      </v-icon>
                      <v-icon v-else>mdi-close</v-icon>
                    </span>
                    <v-divider></v-divider>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import { onMounted, ref, toRefs, onUnmounted } from "@vue/composition-api";
import router from "../router";
import { usePortalProfile } from "@/composables/portal-profile";
import { useTitle } from "@/composables/title";
import PortalOptionsTechnicalCard from "@/components/PortalOptions/PortalOptionsTechnicalCard";
import EditPortalPresentationThemeForm from "@/components/PortalConfiguration/EditPortalPresentationThemeForm";
import EditPortalConfigurationPresentationForm from "@/components/PortalConfiguration/EditPortalConfigurationPresentationForm";
import EditPortalConfigurationLanguageForm from "@/components/PortalConfiguration/EditPortalConfigurationLanguageForm";
import EditPortalConfigurationOtherForm from "@/components/PortalConfiguration/EditPortalConfigurationOtherForm";
import global from "@/composables/global";

export default {
  components: {
    EditPortalConfigurationOtherForm,
    EditPortalConfigurationLanguageForm,
    EditPortalConfigurationPresentationForm,
    EditPortalPresentationThemeForm,
    PortalOptionsTechnicalCard,
  },
  setup() {
    /* Import des API */
    const { setTitle } = useTitle();
    const {
      showPortalProfile,
      portalProfileForm,
      portalProfileData,
      updatePortalConfiguration,
    } = usePortalProfile();

    /* Variables */
    const portalProfileId = router.currentRoute.params.id;
    const editMode = ref(false);
    const editTheme = ref(null);
    const colorsLoading = ref(false);

    /* Méthodes */
    const saveTheme = async function () {
      editMode.value = false;
      colorsLoading.value = true;
      await updatePortalConfiguration(
        String(portalProfileForm.value.id),
        portalProfileForm.value.portalConfiguration,
        false,
        false,
        editTheme.value.portalProfile,
        editTheme.value.portalConfigurationFormRef
      );
      colorsLoading.value = false;
    };

    /* Cycle de vie */
    onMounted(async () => {
      global.tabsDisabled = true;
      global.appTabs = ["Accueil", "Présentation", "Configuration"];
      await showPortalProfile(portalProfileId);
      global.tabsDisabled = false;
      setTitle("Modèle de portail prédéfini - " + portalProfileForm.value.name);
    });
    onUnmounted(() => {
      global.appTabs = [];
      global.selectedAppTab = 0;
    });

    return {
      updatePortalConfiguration,
      portalProfileForm,
      ...toRefs(portalProfileData),
      global,
      editTheme,
      editMode,
      colorsLoading,
      saveTheme,
    };
  },
};
</script>
<style>
.noteCard:hover .nodeBtn {
  visibility: visible;
}
.theme--light.v-tabs-items {
  background-color: #eaeaea;
}
</style>
